import React, { Component } from 'react'
import { connect } from '../../../node_modules/react-redux'
import { Redirect } from 'react-router-dom'

import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'

import { FaCheckCircle, FaRegTimesCircle } from "react-icons/fa";

import BugReportMobile from './BugReportMobile'
import './BugReport.css'

import {reportABug} from '../../store/actions/userActions'


class BugReport extends Component {

    state = {
        reportContent: "",
    }

    handleChange = (e) => {
        this.setState({
          [e.target.id]: e.target.value
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({reportContent: ""})
        this.props.reportABug(this.props.auth.uid, this.state.reportContent)
    }

    render() {
        const { auth, userError, userSuccess } = this.props
        if (!auth.uid) return <Redirect to='/signin' />

        if (window.innerWidth < 1200) {
            return <BugReportMobile auth={auth} userError={userError} userSuccess={userSuccess}/>
        } else return (
            <div className="customDashboardContainer">
                <h1 style={{textAlign: "center"}}>
                    Submit a Bug Report
                </h1>

                <Form>
                    <Form.Group as={Col} controlId="reportContent">
                        <Form.Label>
                            Provide a description of the bug. Please include if you're experiencing this issue on the desktop or mobile version of the site
                        </Form.Label>
                        
                        <Form.Control
                            as="textarea" rows={3}
                            value={this.state.reportContent}
                            onChange={this.handleChange}
                            required
                        />
                    </Form.Group>
                    <Button className="submitButton" onClick={this.handleSubmit}>{"Submit"}</Button>
                </Form>

                <div className="red-text center">
                    { userError ? <div><FaRegTimesCircle className="feedbackIcon"/> {userError}</div> : null }
                </div>

                <div className="green-text center">
                    { userSuccess ? <div><FaCheckCircle className="feedbackIcon"/> {userSuccess}</div> : null }
                </div>
            </div>
        )   
    }
};

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        userError: state.project.err,       // FIX TO state.user
        userSuccess: state.project.success // FIX TO state.user
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
      reportABug: (userID, report) => dispatch(reportABug(userID, report)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BugReport);